// Detects Experience Builder subdomains
export const isExperiencesSubdomain = (
  hostname = typeof window !== 'undefined' && window.location
    ? window.location.hostname
    : '',
): boolean => {
  if (!hostname) return false;
  return (
    hostname.startsWith('experiences-') || hostname.startsWith('experiences.')
  );
};

// Detects Experience Builder subdomains and returns the billing domain
export const getBillingBaseUrl = (
  hostname = window.location.hostname,
): string => {
  if (hostname.startsWith('experiences-')) {
    return `https://${hostname.replace('experiences-', '')}`;
  }
  if (hostname.startsWith('experiences.')) {
    return `https://${hostname.replace('experiences.', '')}`;
  }
  return window.location.origin;
};

const BILLING_PATH_PREFIXES = [
  '/platform/',
  '/apps/',
  '/orders',
  '/services',
  '/reporting',
];

const shouldConvertPath = (pathname: string): boolean => {
  return BILLING_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

const removeExperiencesPrefix = (url: string): string => {
  return url.replace(/^(https?:\/\/)experiences[-.]/, '$1');
};

// Converts Experience Builder nav urls to billing urls
export const convertToBillingUrl = (url: string | undefined): string => {
  if (!url) return '';
  if (!isExperiencesSubdomain()) {
    return url;
  }
  // Handle relative urls
  if (shouldConvertPath(url)) {
    const billingBaseUrl = getBillingBaseUrl();
    return `${billingBaseUrl}${url}`;
  }

  // Handle absolute urls
  try {
    const urlObj = new URL(url);
    if (
      isExperiencesSubdomain(urlObj.hostname) &&
      shouldConvertPath(urlObj.pathname)
    ) {
      return removeExperiencesPrefix(url);
    }
  } catch {
    return url;
  }
  return url;
};
